// Featured-products carousel — used by sections/fresh-featured-carousel.liquid.
//
// Two jobs:
//   1. Drive the slide / thumbnail / arrow carousel.
//   2. Tint the section background to the packaging colour of the active
//      product, sampled from that product's own image. Shopify's CDN sends
//      access-control-allow-origin:*, so a canvas read is allowed as long as
//      the <img> carries crossorigin="anonymous" (the section markup sets it).
//      If the read is ever blocked we keep the merchant's fallback colour.

(function () {
  var SAMPLE = 64;

  // --- colour helpers -------------------------------------------------------

  function channelLin(v) {
    v /= 255;
    return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
  }

  // WCAG relative luminance.
  function relLuminance(r, g, b) {
    return 0.2126 * channelLin(r) + 0.7152 * channelLin(g) + 0.0722 * channelLin(b);
  }

  // Pick the colour a person would call "the colour of the pouch": drop the
  // white studio background and grey shadow, bucket what's left, then score
  // buckets by how common AND how vivid they are. Frequency on its own keeps
  // landing on muddy mid-browns; the saturation term lets the real packaging
  // colour win.
  function dominantColor(img) {
    var canvas = document.createElement('canvas');
    canvas.width = SAMPLE;
    canvas.height = SAMPLE;
    var ctx = canvas.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(img, 0, 0, SAMPLE, SAMPLE);

    var data;
    try {
      data = ctx.getImageData(0, 0, SAMPLE, SAMPLE).data;
    } catch (e) {
      return null; // tainted canvas — caller keeps the fallback colour
    }

    var buckets = {};
    for (var i = 0; i < data.length; i += 4) {
      var r = data[i], g = data[i + 1], b = data[i + 2], a = data[i + 3];
      if (a < 125) continue;
      var mx = Math.max(r, g, b), mn = Math.min(r, g, b);
      if (mn > 232) continue;                     // paper-white background
      if (mx < 24) continue;                      // near-black outline
      if (mx - mn < 18 && mx > 150) continue;     // light grey drop shadow

      var key = (r >> 4) + ',' + (g >> 4) + ',' + (b >> 4);
      var slot = buckets[key] || (buckets[key] = { n: 0, r: 0, g: 0, b: 0 });
      slot.n++; slot.r += r; slot.g += g; slot.b += b;
    }

    var best = null, bestScore = 0;
    for (var k in buckets) {
      var s = buckets[k];
      var r2 = s.r / s.n, g2 = s.g / s.n, b2 = s.b / s.n;
      var m1 = Math.max(r2, g2, b2), m0 = Math.min(r2, g2, b2);
      var sat = m1 === 0 ? 0 : (m1 - m0) / m1;
      var score = s.n * (0.35 + sat);
      if (score > bestScore) { bestScore = score; best = { r: r2, g: g2, b: b2 }; }
    }
    return best;
  }

  // The heading and product title on this band are white, so force the tint
  // dark enough to clear 4.5:1 against white however pale the image was.
  // contrast = 1.05 / (L + 0.05) >= 4.5  =>  L <= 0.1833
  function readableOnWhiteText(c) {
    var r = c.r, g = c.g, b = c.b;
    for (var guard = 0; guard < 40; guard++) {
      if (relLuminance(r, g, b) <= 0.1833) break;
      r *= 0.9; g *= 0.9; b *= 0.9;
    }
    return 'rgb(' + Math.round(r) + ',' + Math.round(g) + ',' + Math.round(b) + ')';
  }

  function whenReady(img, cb) {
    if (img.complete && img.naturalWidth) { cb(); return; }
    img.addEventListener('load', cb, { once: true });
    img.addEventListener('error', function () { cb(); }, { once: true });
  }

  // --- carousel -------------------------------------------------------------

  function initCarousel(root) {
    var track = root.querySelector('[data-fc-track]');
    if (!track) return;

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-fc-slide]'));
    var count = slides.length;
    if (!count) return;

    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-fc-thumb]'));
    var dotsEl = root.querySelector('[data-fc-dots]');
    var prevBtn = root.querySelector('[data-fc-prev]');
    var nextBtn = root.querySelector('[data-fc-next]');
    var fallback = root.getAttribute('data-fc-fallback') || '';
    var autoplayMs = parseInt(root.getAttribute('data-fc-autoplay'), 10) || 0;

    var tints = new Array(count);   // resolved background per slide
    var current = 0;
    var timer = null;

    var dots = [];
    if (dotsEl && count > 1) {
      for (var i = 0; i < count; i++) {
        (function (index) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'fc-dot';
          dot.setAttribute('aria-label', 'Go to product ' + (index + 1));
          dot.addEventListener('click', function () { goTo(index); restart(); });
          dotsEl.appendChild(dot);
          dots.push(dot);
        })(i);
      }
    }

    function paint() {
      var tint = tints[current] || fallback;
      if (tint) root.style.backgroundColor = tint;
    }

    function update() {
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      slides.forEach(function (s, i) {
        s.classList.toggle('is-active', i === current);
        // Keep off-screen slides out of the tab order and the a11y tree.
        s.setAttribute('aria-hidden', i === current ? 'false' : 'true');
        s.querySelectorAll('a, button').forEach(function (el) {
          if (i === current) el.removeAttribute('tabindex');
          else el.setAttribute('tabindex', '-1');
        });
      });
      thumbs.forEach(function (t, i) {
        t.classList.toggle('is-active', i === current);
        t.setAttribute('aria-current', i === current ? 'true' : 'false');
      });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === current); });
      paint();
    }

    function goTo(i) {
      current = (i + count) % count;
      update();
    }

    function restart() {
      if (!autoplayMs) return;
      if (timer) clearInterval(timer);
      timer = setInterval(function () { goTo(current + 1); }, autoplayMs);
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); restart(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); restart(); });
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { goTo(i); restart(); });
    });

    var touchStartX = 0;
    track.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });
    track.addEventListener('touchend', function (e) {
      var diff = e.changedTouches[0].clientX - touchStartX;
      if (diff > 40) { goTo(current - 1); restart(); }
      if (diff < -40) { goTo(current + 1); restart(); }
    });

    if (autoplayMs) {
      root.addEventListener('mouseenter', function () { if (timer) clearInterval(timer); });
      root.addEventListener('mouseleave', restart);
    }

    // Sample every slide image once, then repaint so the active slide picks up
    // its real colour as soon as it is known.
    slides.forEach(function (slide, i) {
      var img = slide.querySelector('[data-fc-image]');
      if (!img) return;
      whenReady(img, function () {
        if (!img.naturalWidth) return;
        var c = dominantColor(img);
        if (c) tints[i] = readableOnWhiteText(c);
        if (i === current) paint();
      });
    });

    update();
    restart();
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-featured-carousel]').forEach(initCarousel);
  });
})();
